import {useStyles} from '../../shared/hooks/styles';
import {DeviceSize} from '../../shared/theme/helpers';

export const useCertificateItemStyles = () => {
  return useStyles(({theme, mediaOnly, deviceSize}) => ({
    sectionContainer: {
      ...mediaOnly(DeviceSize.mobile, {paddingHorizontal: 16, marginTop: 16}, {marginTop: 32}),
      ...mediaOnly(DeviceSize.tablet, {paddingHorizontal: 35}, {}),
      ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 60}, {}),
      backgroundColor: theme.screen.container[deviceSize].backgroundColor,
    },
    tabsContainer: {
      ...mediaOnly(DeviceSize.desktop, {paddingTop: 52}),
    },
    title: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h2, theme.fonts.action),
      color: theme.color.textColor,
    },
  }));
};
